import { getDefaultPortalScope } from 'services/global.service';
import { getPortalScope, setPortalScope } from 'utils/portalScope';

const hasCompletePortalScope = (scope = {}) =>
  Boolean(scope?.company_id && scope?.business_id && scope?.store_id);

export const ensureAuthenticatedPortalScope = async ({ force = false } = {}) => {
  const currentScope = getPortalScope();

  if (!force && hasCompletePortalScope(currentScope)) {
    return { is_scoped: true, scope: currentScope };
  }

  let defaultScope;
  try {
    defaultScope = await getDefaultPortalScope();
  } catch (error) {
    // Keep login compatible while the portal and API are deployed separately.
    // A legacy API does not expose this optional bootstrap route yet; users can
    // still enter the portal and select their working scope through the header.
    if (Number(error?.status) === 404) {
      return { is_scoped: false, scope: currentScope };
    }
    throw error;
  }

  if (!defaultScope?.is_scoped) {
    return { is_scoped: false, scope: currentScope };
  }

  if (!hasCompletePortalScope(defaultScope.scope)) {
    throw new Error('Tài khoản chưa được phân cửa hàng hợp lệ.');
  }

  return {
    ...defaultScope,
    scope: setPortalScope(defaultScope.scope, { notify: false }),
  };
};

export { hasCompletePortalScope };
